'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _baseBcReactComponent = require('@bibliocommons/base-bc-react-component');

var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);

var _baseFullScreenOverlay = require('@bibliocommons/base-full-screen-overlay');

var _baseFullScreenOverlay2 = _interopRequireDefault(_baseFullScreenOverlay);

var _loginForm = require('../../login-form');

var _loginForm2 = _interopRequireDefault(_loginForm);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LoginOverlay = function (_BcReactComponent) {
  _inherits(LoginOverlay, _BcReactComponent);

  function LoginOverlay() {
    _classCallCheck(this, LoginOverlay);

    return _possibleConstructorReturn(this, (LoginOverlay.__proto__ || Object.getPrototypeOf(LoginOverlay)).apply(this, arguments));
  }

  _createClass(LoginOverlay, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      if ('parentIFrame' in window && prevProps.loginOverlayOpen !== this.props.loginOverlayOpen) {
        var resizer = window.parentIFrame;
        if (this.props.loginOverlayOpen) {
          resizer.autoResize(false);
          resizer.size(this._loginForm._root.parentElement.scrollHeight);
        } else if (!this.props.loginOverlayOpen) {
          resizer.autoResize(true);
        }
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          handleClose = _props.handleClose,
          login = _props.login,
          loginErrorMessage = _props.loginErrorMessage,
          loginOverlayOpen = _props.loginOverlayOpen,
          loading = _props.loading,
          numericPasswordRequired = _props.numericPasswordRequired,
          getCardLink = _props.getCardLink;

      return _react2.default.createElement(
        _baseFullScreenOverlay2.default,
        { open: loginOverlayOpen, handleClose: handleClose, className: (0, _classnames2.default)('cp-login-overlay', { 'is-widget': this.context.isWidget }) },
        _react2.default.createElement(_loginForm2.default, {
          ref: function ref(el) {
            _this2._loginForm = el;
          },
          login: login,
          loginErrorMessage: loginErrorMessage,
          handleClose: handleClose,
          loading: loading,
          numericPasswordRequired: numericPasswordRequired,
          getCardLink: getCardLink })
      );
    }
  }]);

  return LoginOverlay;
}(_baseBcReactComponent2.default);

LoginOverlay.propTypes = {
  login: _react.PropTypes.func.isRequired,
  handleClose: _react.PropTypes.func.isRequired,
  loginErrorMessage: _react.PropTypes.string,
  loginOverlayOpen: _react.PropTypes.bool,
  loading: _react.PropTypes.bool,
  numericPasswordRequired: _react.PropTypes.bool,
  getCardLink: _react.PropTypes.string
};

LoginOverlay.contextTypes = {
  isWidget: _react.PropTypes.bool
};

exports.default = LoginOverlay;


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/login/lib/components/login-overlay/components/LoginOverlay.component.js
// module id = 1427
// module chunks = 1